import React from 'react';
import classNames from 'classnames/bind';
import Text from '../../../../../atoms/Text';
import BackIcon from '../../common/BackIcon';
import styles from './index.module.pcss';
import { HOME_PAGE_URL } from '../../../Constants';
import { replaceWithJioCDN } from '../../../../../../utils/imageHandling';

interface MainHeaderProps {
  platform: string;
  topShopperHeader: string;
  topShopperSubHeader: string;
  image: string;
}

const cx = classNames.bind(styles);

function MainHeader(props: MainHeaderProps): JSX.Element {
  const { platform = '', topShopperHeader, topShopperSubHeader, image } = props;
  return (
    <div className={cx('MainHeaderContainer')}>
      <a
        href={HOME_PAGE_URL}
        className={cx('event-anchor-cta', `${platform === 'app' ? 'ele-hidden' : ''}`)}
      >
        <BackIcon className={cx('backarrow')} />
      </a>
      <Text weight="bold" variant="T5" color="White">
        {topShopperHeader}
      </Text>
      <div className={cx('header-subHeader')}>
        <Text weight="bold" variant="T6" color="White">
          {topShopperSubHeader}
        </Text>
      </div>
      <img className={cx('ballonImage')} alt="ballon" src={replaceWithJioCDN(image)} />
    </div>
  );
}

MainHeader.defaultProps = {
  className: ''
};

export default MainHeader;
